import {
  SELECT_ARRIVAL, SELECT_DURATION, SELECT_MEALPLAN, SELECT_ROOMTYPE,
} from '../actions';

export function selection(state = {
  selectedMealplan: null, selectedRoomtype: null, selectedDuration: null, selectedArrival: null,
}, action) {
  switch (action.type) {
    case SELECT_MEALPLAN:
      return state = {
        ...state,
        selectedMealplan: action.selectedMealplan,
        dates: null,
      };
    case SELECT_ROOMTYPE:
      return state = {
        ...state,
        selectedRoomtype: action.selectedRoomtype,
        dates: null,
      };
    case SELECT_DURATION:
      return state = {
        ...state,
        selectedDuration: action.selectedDuration,
        dates: null,
      };
    case SELECT_ARRIVAL:
      return state = {
        ...state,
        selectedArrival: action.selectedArrival,
      };
  }

  return state;
}
